// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1U6nG","content":"styles_content__3qalf","checkbox":"styles_checkbox__1o0f6","checkboxLabel":"styles_checkboxLabel__37Qvt"};